/**
 * Formats a phone number to XXX-XXX-XXXX format
 * @param {string} value - The phone number value to format
 * @returns {string} - Formatted phone number (XXX-XXX-XXXX)
 */
export const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const phoneNumber = value.replace(/\D/g, '').slice(0, 10); // Limit to 10 digits
    
    // Format as XXX-XXX-XXXX
    if (phoneNumber.length <= 3) {
        return phoneNumber;
    } else if (phoneNumber.length <= 6) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    } else {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }
};

